import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useUpdateProfileOkModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage, includesTitleBottomMargin: true });

  function didOpen() {
    analyticsPageView('Profile Updated');
  }

  async function fire(name) {
    await swal.fire({
      title: t('update-profile-ok-modal.title', { name }),
      icon: 'success',
      timer: layoutDefaults.modalTimer,
      didOpen,
      // didClose: resolve,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
    });

    // return new Promise((resolve) => {
    //   swal.fire({
    //     title: `Pronto, ${name}!`,
    //     icon: 'success',
    //     timer: layoutDefaults.modalTimer,
    //     didOpen: onOpen,
    //     didClose: resolve,
    //     showConfirmButton: false,
    //     showDenyButton: false,
    //     showCancelButton: false,
    //   });
    // });
  }

  return fire;
}

export { useUpdateProfileOkModal };
